import { z } from "zod"

export interface CustomStoreInfo {
  id: string
  storeId: string
  icon: string
  text: string
  displayOrder: number
}

export const CreateCustomStoreInfoSchema = z.object({
  icon: z.string().min(1).max(50),
  text: z.string().min(1).max(100),
  displayOrder: z.number().int().optional(),
})

export type CreateCustomStoreInfo = z.infer<typeof CreateCustomStoreInfoSchema>
